import React, { useState } from "react";
import { AiOutlineDashboard } from "react-icons/ai";
import { RiArrowDropDownLine } from "react-icons/ri";
import { GoDot } from "react-icons/go";
import { NavLink } from "react-router-dom";

function SidenavItem({ menu, open, hoverOpen }) {
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  return (
    <>
      <li>
        {menu.link && (
          <NavLink
            className={`relative text-sm flex item-center gap-x-2 cursor-pointer p-1 text-gray-500 hover:text-white hover:bg-gradient-to-r from-d-bg to-d-bg-light rounded transition-all ${
              menu.spacing ? "mt-9" : "mt-2"
            }`}
            style={({ isActive }) => {
              return !menu.commingSoon
                ? {
                    backgroundImage: isActive
                      ? "linear-gradient(to right, var(--color-d-bg), var(--color-d-bg-light))"
                      : "",
                    color: isActive ? "#fff" : "",
                  }
                : {};
            }}
            onClick={() => setSubMenuOpen(!subMenuOpen)}
            to={menu.commingSoon ? "#" : menu.link}
            end
          >
            <span>
              {menu.icon ? (
                menu.icon
              ) : (
                <AiOutlineDashboard className="text-2xl block float-left" />
              )}
            </span>
            <span
              className={`text-base flex-1 ${!hoverOpen && !open && "hidden"}`}
            >
              {menu.label}
            </span>
            {menu.submenu && (hoverOpen || open) && (
              <RiArrowDropDownLine
                className={`text-3xl block ${
                  subMenuOpen && "rotate-180"
                } transition-all`}
              />
            )}
            {menu.commingSoon && (
              <span className="text-[0.5rem] font-medium leading-snug absolute right-1 top-3 bg-red-500 rounded-full px-1 py-0 text-white">
                Comming Soon
              </span>
            )}
          </NavLink>
        )}

        {menu.submenu && (
          <button
            className={`text-sm w-full flex item-center justify-between gap-x-2 cursor-pointer p-1 text-gray-500 hover:text-white hover:bg-gradient-to-r from-d-bg to-d-bg-light rounded transition-all ${
              menu.spacing ? "mt-9" : "mt-2"
            }`}
            onClick={() => setSubMenuOpen(!subMenuOpen)}
          >
            <span className="flex gap-2">
              <span>
                {menu.icon || (
                  <AiOutlineDashboard className="text-2xl block float-left" />
                )}
              </span>
              <span
                className={`text-base flex-1 ${
                  !hoverOpen && !open && "hidden"
                }`}
              >
                {menu.label}
              </span>
            </span>
            {menu.submenu && (hoverOpen || open) && (
              <RiArrowDropDownLine
                className={`text-3xl block ${
                  subMenuOpen && "rotate-180"
                } transition-all`}
              />
            )}
          </button>
        )}

        {menu.submenu && (hoverOpen || open) && (
          <div
            className={`grid ${
              !subMenuOpen ? "grid-rows-[0fr]" : "grid-rows-[1fr]"
            } transition-all duration-700`}
          >
            <ul className={`overflow-hidden`}>
              {menu.submenuItems.map((submenuItems, index) => (
                <li key={index}>
                  <NavLink
                    className={`relative text-gray-500 text-sm flex items-center gap-x-4 cursor-pointer p-2 px-5 my-1 rounded hover:text-white hover:bg-gradient-to-r from-d-bg to-d-bg-light transition-all`}
                    to={submenuItems.commingSoon ? "#" : submenuItems.link}
                    style={({ isActive }) => {
                      return !submenuItems.commingSoon
                        ? {
                            backgroundImage: isActive
                              ? "linear-gradient(to right, var(--color-d-bg), var(--color-d-bg-light))"
                              : "",
                            color: isActive ? "#fff" : "",
                          }
                        : {};
                    }}
                  >
                    <GoDot />
                    <span>{submenuItems.label}</span>
                    {submenuItems.commingSoon && (
                      <span className="text-[0.5rem] font-medium leading-snug absolute right-1 top-3 bg-red-500 rounded-full px-1 py-0 text-white">
                        Comming Soon
                      </span>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}
      </li>
    </>
  );
}

export default SidenavItem;
